
export const TOTAL_TIME = 60000; // 60 seconds in milliseconds
export const UPDATE_INTERVAL = 100; // Update every 100ms
export const MESSAGE_CHANGE_INTERVAL = 2500; // Change message every 2.5 seconds
export const BLINK_DURATION = 300; // Duration of the blink animation in milliseconds
export const TIMEOUT_DURATION = 120000; // 120 seconds timeout

export const messages = [
  { emoji: "🔍", text: "Pesquisando palavra-chave no Google..." },
  { emoji: "📊", text: "Descobrindo volume de buscas..." },
  { emoji: "📈", text: "Analisando tendência dos últimos 12 meses..." },
  { emoji: "🎯", text: "Calculando Nota On-Page da página..." },
  { emoji: "📝", text: "Verificando título e meta description..." },
  { emoji: "🔗", text: "Analisando backlinks..." },
  { emoji: "🌐", text: "Avaliando domínios de referência..." },
  { emoji: "⭐", text: "Calculando PageRank..." },
  { emoji: "🏆", text: "Comparando com concorrentes..." },
  { emoji: "📱", text: "Preparando relatório..." }
];

export const overtimeMessages = [
  { emoji: "⚡", text: "Analisando dados complexos da página..." },
  { emoji: "💪", text: "Processando grande volume de backlinks..." },
  { emoji: "🔄", text: "Aguardando resposta das APIs..." },
  { emoji: "⏳", text: "Esta análise está levando mais tempo que o normal..." },
  { emoji: "🚀", text: "Quase lá! Finalizando análise..." }
];
